export enum PurchasePeriodE {
  yearly = "Price_Early",
  monthly = "Price_Monthly",
}

export enum SelectedOptionE {
  YEARLY = "yearly",
  MONTHLY = "monthly",
  // JUMBOcodes
  FIVE_CODES = 5,
  TEN_CODES = 10,
  TWENTY_CODES = 20,
}

export enum JumboMailTransactionStatusE {
  CREATED = "CREATED",
  FAILED = "FAILED",
  SUCCESS = "SUCCESS",
  CANCELLED = "CANCELLED",
  INACTIVE = 'INACTIVE',
}

export enum CurrencyE {
  USD = "USD",
  ILS = "ILS",
  EUR = "EUR",
}

export enum CurrencySymbolE {
  USD = "$",
  ILS = "₪",
  EUR = "€",
}

export enum BillingPaymentGatewayE {
  PeleCard = "PeleCard",
  PayPal = "PayPal",
  WIRE = "WIRE",
}

// Uses as well as Subscription System Name and Subscription type
export enum PlanPackagesE {
  pro = "pro",
  business = "business",
  premium = "premium",
}

export enum BillingTransactionStatusE {
  SUCCESS,
  FAILED,
}

export enum AddonStatusE {
  PROCESSING,
  ACTIVE,
  CANCELLED,
}

export enum AddonNameE {
  SUB_USERS = "sub-users",
  EXTRA_STORAGE = "extra-storage",
}

export enum PaymentTypeE {
  PAYPAL = "paypal",
  NEW_CREDIT_CARD = "newcreditcard",
  CREDIT_CARD = "creditcard",
}

export enum PurchaseStepE {
  PRIMARY_PURCHASE_STEP = 0,
  FIRST_PURCHASE_METHOD_STEP = 1,
  SECOND_INVOICE_DETAILS_STEP = 2,
  THIRD_PAYMENT_STEP = 3,
}

export enum DowngradeDetailsTypeE {
  SUB_USERS = "jumbomail-sub-users",
  EXTRA_STORAGE = "jumbomail-extra-storage",
  CODES = "jumbomail-uploadcodes",
  RENEWABLE_SUBSCRIPTION = "jumbomail-renewable-subscription",
  SUBSCRIPTION = "jumbomail-subscription",
  RENEWABLE_EMBED = "jumbomail-renewable-embed",
  EMBED = "jumbomail-embed",
}

export enum PackagePeriodsE {
  MONTHLY = 1,
  YEARLY = 12,
}